export default __webpack_public_path__ + "static/media/person3.76a612e6.png";